const pricelistI18n = {
  "fr": {
    "pricelist": {
      "loading": "Chargement…",
      "loadError": "Chargement impossible.",
      "title": "On rachète :",
      "search": "Rechercher un modèle ou une marque…",
      "emptyBrands": "Aucune marque.",
      "filters": {
        "all": "Tous"
      },
      "parts": {
        "tabs": {
          "screen": "Écrans",
          "motherboard": "Carte mère",
          "charging": "Connecteur charge",
          "camera": "Caméra"
        }
      },
      "chips": {
        "models": {
          "one": "modèle",
          "other": "modèles"
        },
        "partsSuffix": "pièces détachées"
      },
      "tooltips": {
        "collapse": "Réduire",
        "expand": "Dérouler",
        "hideComponents": "Masquer les composants",
        "showComponents": "Voir les composants"
      },
      "empty": {
        "noModelsForBrand": "Aucun modèle pour cette marque.",
        "noComponentsForModel": "Aucun composant pour ce modèle."
      },
      "price": {
        "onExpertise": "Prix sur expertise"
      },
      "prefix": {
        "screen": "Écran",
        "phone": "Téléphone",
        "modelMotherboard": "Modèle (carte mère)",
        "modelCharging": "Modèle (connecteur charge)",
        "modelCamera": "Modèle (caméra)"
      },
      "batchSort": {
        "title": "Envoie, on trie pour toi !",
        "desc": "Envoie tous tes écrans sans perdre de temps — on génère ton bordereau automatiquement. Nous trions tes écrans et, après tests, tu reçois un rapport de rachat détaillé à valider pour être payé par virement bancaire."
      },
      "disclaimer": {
        "short": "À la réception, vos appareils et pièces sont testés et classés (A/B/C). Le prix affiché est indicatif et peut varier selon l’état réel, la demande et les cours du marché. Une offre finale vous est envoyée après expertise."
      },
      "type": {
        "productBullet": "produit"
      }
    }
  },
  "en": {
    "pricelist": {
      "loading": "Loading…",
      "loadError": "Unable to load.",
      "title": "We buy:",
      "search": "Search a model or brand…",
      "emptyBrands": "No brands.",
      "filters": {
        "all": "All"
      },
      "parts": {
        "tabs": {
          "screen": "Screens",
          "motherboard": "Mainboard",
          "charging": "Charging port",
          "camera": "Camera"
        }
      },
      "chips": {
        "models": {
          "one": "model",
          "other": "models"
        },
        "partsSuffix": "spare parts"
      },
      "tooltips": {
        "collapse": "Collapse",
        "expand": "Expand",
        "hideComponents": "Hide components",
        "showComponents": "Show components"
      },
      "empty": {
        "noModelsForBrand": "No models for this brand.",
        "noComponentsForModel": "No components for this model."
      },
      "price": {
        "onExpertise": "Price upon inspection"
      },
      "prefix": {
        "screen": "Screen",
        "phone": "Phone",
        "modelMotherboard": "Model (motherboard)",
        "modelCharging": "Model (charging port)",
        "modelCamera": "Model (camera)"
      },
      "batchSort": {
        "title": "Send it, we'll sort it for you!",
        "desc": "Send all your screens without losing time — we generate your shipping label automatically. We sort your screens and, after testing, you receive a detailed buyback report to approve in order to get paid by bank transfer."
      },
      "disclaimer": {
        "short": "Upon arrival, your devices and parts are tested and graded (A/B/C). Displayed prices are indicative and may vary based on actual condition, demand, and market trends. A final offer is sent after inspection."
      },
      "type": {
        "productBullet": "product"
      }
    }
  },
  "pl": {
    "pricelist": {
      "loading": "Ładowanie…",
      "loadError": "Nie udało się wczytać.",
      "title": "Skupujemy:",
      "search": "Szukaj modelu lub marki…",
      "emptyBrands": "Brak marek.",
      "filters": {
        "all": "Wszystkie"
      },
      "parts": {
        "tabs": {
          "screen": "Ekrany",
          "motherboard": "Płyta główna",
          "charging": "Złącze ładowania",
          "camera": "Aparat"
        }
      },
      "chips": {
        "models": {
          "one": "model",
          "other": "modele"
        },
        "partsSuffix": "części zamienne"
      },
      "tooltips": {
        "collapse": "Zwiń",
        "expand": "Rozwiń",
        "hideComponents": "Ukryj komponenty",
        "showComponents": "Pokaż komponenty"
      },
      "empty": {
        "noModelsForBrand": "Brak modeli dla tej marki.",
        "noComponentsForModel": "Brak komponentów dla tego modelu."
      },
      "price": {
        "onExpertise": "Cena po weryfikacji"
      },
      "prefix": {
        "screen": "Ekran",
        "phone": "Telefon",
        "modelMotherboard": "Model (płyta główna)",
        "modelCharging": "Model (złącze ładowania)",
        "modelCamera": "Model (aparat)"
      },
      "batchSort": {
        "title": "Wyślij, a my posortujemy za Ciebie!",
        "desc": "Wyślij wszystkie swoje ekrany bez tracenia czasu — generujemy etykietę wysyłkową automatycznie. Po sortowaniu i testach otrzymasz szczegółowy raport odkupu do zatwierdzenia, aby otrzymać płatność przelewem bankowym."
      },
      "disclaimer": {
        "short": "Po otrzymaniu urządzenia i części są testowane i klasyfikowane (A/B/C). Podane ceny są orientacyjne i mogą ulec zmianie w zależności od stanu, popytu i sytuacji rynkowej. Ostateczna oferta jest wysyłana po weryfikacji."
      },
      "type": {
        "productBullet": "produkt"
      }
    }
  },
  "es": {
    "pricelist": {
      "loading": "Cargando…",
      "loadError": "No se pudo cargar.",
      "title": "Compramos:",
      "search": "Buscar un modelo o marca…",
      "emptyBrands": "No hay marcas.",
      "filters": {
        "all": "Todos"
      },
      "parts": {
        "tabs": {
          "screen": "Pantallas",
          "motherboard": "Placa base",
          "charging": "Conector de carga",
          "camera": "Cámara"
        }
      },
      "chips": {
        "models": {
          "one": "modelo",
          "other": "modelos"
        },
        "partsSuffix": "piezas de repuesto"
      },
      "tooltips": {
        "collapse": "Contraer",
        "expand": "Desplegar",
        "hideComponents": "Ocultar componentes",
        "showComponents": "Ver componentes"
      },
      "empty": {
        "noModelsForBrand": "No hay modelos para esta marca.",
        "noComponentsForModel": "No hay componentes para este modelo."
      },
      "price": {
        "onExpertise": "Precio tras inspección"
      },
      "prefix": {
        "screen": "Pantalla",
        "phone": "Teléfono",
        "modelMotherboard": "Modelo (placa base)",
        "modelCharging": "Modelo (conector de carga)",
        "modelCamera": "Modelo (cámara)"
      },
      "batchSort": {
        "title": "¡Envíalo, nosotros lo clasificamos por ti!",
        "desc": "Envía todas tus pantallas sin perder tiempo — generamos automáticamente tu etiqueta de envío. Clasificamos tus pantallas y, tras las pruebas, recibirás un informe detallado de recompra que deberás aprobar para recibir el pago por transferencia bancaria."
      },
      "disclaimer": {
        "short": "A la recepción, tus dispositivos y piezas son probados y clasificados (A/B/C). Los precios mostrados son orientativos y pueden variar según el estado real, la demanda y el mercado. Se te enviará una oferta final tras la inspección."
      },
      "type": {
        "productBullet": "producto"
      }
    }
  },
  "it": {
    "pricelist": {
      "loading": "Caricamento...",
      "loadError": "Incapace di caricare.",
      "title": "Compriamo:",
      "search": "Cerca un modello o un marchio...",
      "emptyBrands": "Niente marchi.",
      "filters": {
        "all": "Tutti"
      },
      "parts": {
        "tabs": {
          "screen": "Schermi",
          "motherboard": "Scheda madre",
          "charging": "Porta di ricarica",
          "camera": "Macchina fotografica"
        }
      },
      "chips": {
        "models": {
          "one": "modello modello",
          "other": "modelli"
        },
        "partsSuffix": "pezzi di ricambio"
      },
      "tooltips": {
        "collapse": "Colpo",
        "expand": "Espulsione",
        "hideComponents": "Nascondi componenti",
        "showComponents": "Mostra componenti"
      },
      "empty": {
        "noModelsForBrand": "Nessun modello per questo marchio.",
        "noComponentsForModel": "Nessun componente per questo modello."
      },
      "price": {
        "onExpertise": "Prezzo all'ispezione"
      },
      "prefix": {
        "screen": "Schermo",
        "phone": "Telefono",
        "modelMotherboard": "Modello (maschera)",
        "modelCharging": "Modello (porta di carico)",
        "modelCamera": "Modello (camera)"
      },
      "batchSort": {
        "title": "Mandalo, lo risolveremo per te!",
        "desc": "Invia tutti i tuoi schermi senza perdere tempo — generiamo la tua etichetta di spedizione automaticamente. Noi ordinare i vostri schermi e, dopo la prova, si riceve un dettagliato rapporto di buyback per approvare per ottenere pagato tramite bonifico bancario."
      },
      "disclaimer": {
        "short": "All'arrivo, i dispositivi e le parti sono testati e classificati (A/B/C). I prezzi visualizzati sono indicativi e possono variare in base alle condizioni reali, alla domanda e alle tendenze del mercato. Un'offerta finale viene inviata dopo l'ispezione."
      },
      "type": {
        "productBullet": "prodotto"
      }
    }
  },
  "de": {
    "pricelist": {
      "loading": "Beladung...",
      "loadError": "Unfähig zu laden.",
      "title": "Wir kaufen:",
      "search": "Suche ein Modell oder eine Marke...",
      "emptyBrands": "Keine Marken.",
      "filters": {
        "all": "alle"
      },
      "parts": {
        "tabs": {
          "screen": "Bildschirme",
          "motherboard": "Motherboard",
          "charging": "Ladehafen",
          "camera": "Kamera"
        }
      },
      "chips": {
        "models": {
          "one": "Modell",
          "other": "Modelle"
        },
        "partsSuffix": "Ersatzteile"
      },
      "tooltips": {
        "collapse": "Kollaps",
        "expand": "Expansion",
        "hideComponents": "Hüllkomponenten",
        "showComponents": "Komponenten anzeigen"
      },
      "empty": {
        "noModelsForBrand": "Keine Modelle für diese Marke.",
        "noComponentsForModel": "Keine Komponenten für dieses Modell."
      },
      "price": {
        "onExpertise": "Preis bei Inspektion"
      },
      "prefix": {
        "screen": "Bildschirm",
        "phone": "Telefon",
        "modelMotherboard": "Modell (Motherboard)",
        "modelCharging": "Modell (Ladeanschluss)",
        "modelCamera": "Modell (Kamera)"
      },
      "batchSort": {
        "title": "Schick es, wir sortieren es für dich!",
        "desc": "Senden Sie alle Ihre Bildschirme, ohne Zeit zu verlieren - wir generieren Ihr Versandetikett automatisch. Wir sortieren Ihre Bildschirme und nach dem Test erhalten Sie einen detaillierten Rückkaufbericht, den Sie genehmigen müssen, um per Banküberweisung bezahlt zu werden."
      },
      "disclaimer": {
        "short": "Bei der Ankunft werden Ihre Geräte und Teile getestet und bewertet (A/B/C). Die angezeigten Preise sind Richtwerte und können je nach Zustand, Nachfrage und Markttrends variieren. Ein endgültiges Angebot wird nach der Inspektion gesendet."
      },
      "type": {
        "productBullet": "Produkt"
      }
    }
  },
  "pt": {
    "pricelist": {
      "loading": "Carregando...",
      "loadError": "Incapaz de carregar.",
      "title": "Nós compramos:",
      "search": "Procurar um modelo ou marca...",
      "emptyBrands": "Sem marcas.",
      "filters": {
        "all": "Tudo"
      },
      "parts": {
        "tabs": {
          "screen": "Ecrãs",
          "motherboard": "Painel principal",
          "charging": "Porta de carregamento",
          "camera": "Câmera"
        }
      },
      "chips": {
        "models": {
          "one": "modelo",
          "other": "modelos"
        },
        "partsSuffix": "peças sobressalentes"
      },
      "tooltips": {
        "collapse": "Recolher",
        "expand": "Expandir",
        "hideComponents": "Ocultar componentes",
        "showComponents": "Mostrar os componentes"
      },
      "empty": {
        "noModelsForBrand": "Não há modelos para esta marca.",
        "noComponentsForModel": "Nenhum componente para este modelo."
      },
      "price": {
        "onExpertise": "Preço aquando da inspecção"
      },
      "prefix": {
        "screen": "Ecrã",
        "phone": "Telefone",
        "modelMotherboard": "Modelo (matriz)",
        "modelCharging": "Modelo (porta de carregamento)",
        "modelCamera": "Modelo (câmera)"
      },
      "batchSort": {
        "title": "Manda-o, nós tratamos disso!",
        "desc": "Envie todas as suas ecrãs sem perder tempo – nós geramos sua etiqueta de envio automaticamente. Nós classificamos suas ecrãs e, após os testes, você recebe um relatório detalhado de resgate para aprovar, a fim de ser pago por transferência bancária."
      },
      "disclaimer": {
        "short": "Após a chegada, seus dispositivos e peças são testados e classificados (A/B/C). Os preços apresentados são indicativos e podem variar com base na condição real, demanda e tendências do mercado. Uma oferta final é enviada após a inspeção."
      },
      "type": {
        "productBullet": "produto"
      }
    }
  },
  "cs": {
    "pricelist": {
      "loading": "Nabíjím...",
      "loadError": "Nelze načíst.",
      "title": "Kupujeme:",
      "search": "Hledat model nebo značku...",
      "emptyBrands": "Žádné značky.",
      "filters": {
        "all": "Všechny"
      },
      "parts": {
        "tabs": {
          "screen": "Obrazovky",
          "motherboard": "Základní deska",
          "charging": "Port nabíjení",
          "camera": "Kamera"
        }
      },
      "chips": {
        "models": {
          "one": "model",
          "other": "modely"
        },
        "partsSuffix": "náhradní díly"
      },
      "tooltips": {
        "collapse": "Kolaps",
        "expand": "Rozbalit",
        "hideComponents": "Skrýt komponenty",
        "showComponents": "Zobrazit komponenty"
      },
      "empty": {
        "noModelsForBrand": "Žádné modely pro tuto značku.",
        "noComponentsForModel": "Žádné komponenty pro tento model."
      },
      "price": {
        "onExpertise": "Cena při kontrole"
      },
      "prefix": {
        "screen": "Obrazovka",
        "phone": "Telefon",
        "modelMotherboard": "Vzor (základní deska)",
        "modelCharging": "Model (nabíjecí port)",
        "modelCamera": "Model (kamera)"
      },
      "batchSort": {
        "title": "Pošli to, my to pro tebe vyřešíme!",
        "desc": "Poslat všechny obrazovky bez ztráty času - jsme generovat vaše přepravní štítek automaticky. Setřídíme vaše obrazovky a po otestování obdržíte podrobnou zprávu o zpětném odkupu, abyste dostali zaplaceno bankovním převodem."
      },
      "disclaimer": {
        "short": "Po příjezdu jsou vaše zařízení a části testovány a klasifikovány (A / B / C). Zobrazené ceny jsou orientační a mohou se lišit na základě skutečných podmínek, poptávky a tržních trendů. Konečná nabídka je zaslána po kontrole."
      },
      "type": {
        "productBullet": "Výrobek"
      }
    }
  },
  "nl": {
    "pricelist": {
      "loading": "Laden...",
      "loadError": "Kan niet laden.",
      "title": "We kopen:",
      "search": "Zoek een model of merk...",
      "emptyBrands": "Geen merken.",
      "filters": {
        "all": "Alles"
      },
      "parts": {
        "tabs": {
          "screen": "Schermen",
          "motherboard": "Mainboard",
          "charging": "Laadpoort",
          "camera": "Camera"
        }
      },
      "chips": {
        "models": {
          "one": "model",
          "other": "modellen"
        },
        "partsSuffix": "reserveonderdelen"
      },
      "tooltips": {
        "collapse": "Inklappen",
        "expand": "Uitvouwen",
        "hideComponents": "Onderdelen verbergen",
        "showComponents": "Onderdelen tonen"
      },
      "empty": {
        "noModelsForBrand": "Geen modellen voor dit merk.",
        "noComponentsForModel": "Geen onderdelen voor dit model."
      },
      "price": {
        "onExpertise": "Prijs bij inspectie"
      },
      "prefix": {
        "screen": "Scherm",
        "phone": "Telefoon",
        "modelMotherboard": "Model (moederbord)",
        "modelCharging": "Model (laadhaven)",
        "modelCamera": "Model (camera)"
      },
      "batchSort": {
        "title": "Stuur het, we regelen het voor je!",
        "desc": "Stuur al uw schermen zonder tijd te verliezen We genereren uw verzendlabel automatisch. We sorteren uw schermen en, na het testen, ontvangt u een gedetailleerd terugkopen rapport om te keuren om betaald te worden via overschrijving."
      },
      "disclaimer": {
        "short": "Bij aankomst worden uw apparaten en onderdelen getest en ingedeeld (A/B/C). Weergegeven prijzen zijn indicatief en kunnen variëren op basis van feitelijke toestand, vraag en markttrends. Na inspectie wordt een laatste bod gedaan."
      },
      "type": {
        "productBullet": "product"
      }
    }
  }
};

export default pricelistI18n;
